// import tracingList from '../components/tracing/tracingList.vue'

export default [
    {
        path: 'tracing/tracingList',
        component: resolve => require(['@/components/tracing/tracingList'],resolve),
        name:"TracingList",
        meta:{
            id:'856',
            node:'tracing',
            url:'tracingList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/tracing.js